import { Injectable, Injector } from '@angular/core';
import { Store } from '@ngrx/store';
import { StoresBaseGuard } from './stores.guard-extender';
import * as fromActions from '@stores/profile/profile.actions';
import * as fromReducer from '@stores/profile/profile.reducer';

@Injectable()
export class ProfileGuard extends StoresBaseGuard {
  successAction = fromActions.setProfile;
  errorAction = fromActions.loadFailure;

  constructor(injector: Injector, private store: Store<fromReducer.State>) {
    super(injector);
  }

  dispatcher() {
    this.store.dispatch(fromActions.loadProfile());
  }
}
